export interface ComplianceCheckDetails {
  clientTeamExternalName: string | null;
  clientTeamEmailAddress: string | null;
  languageCode: string | null;
  contactPersonFirstName: string | null;
  entity: ComplianceCheckEntity | null;
  reason: ComplianceCheckReason | null;
  status: ComplianceCheckStatus | null;
  customerName: string | null;
  supplierName: string | null;
  contractStartDate: Date | null;
  contractEndDate: Date | null;
  assignmentNumber: string | null;
  functionTitle: string | null;
  professionalName: string | null;
  jobActivities: string | null;
  complianceCheckExpiryDate: Date | null;
}

export enum ComplianceCheckEntity {
  NotSpecified = 0,
  Supplier = 1,
  Customer = 2,
}

export enum ComplianceCheckReason {
  NotSpecified = 0,
  Extension = 1,
  Periodically = 2,
  AfterStartAssignment = 3,
}

export enum ComplianceCheckStatus {
  NotSpecified = 0,
  WaitingForResponse = 1,
  FirstReminderSent = 2,
  WaitingForReview = 3,
  AutomaticallyReviewed = 4,
  Reviewed = 5,
  SecondReminderSent = 6,
  Aborted = 7,
  NoResponseEndmailSent = 8,
}

export class ProcessComplianceCheckRequest {
  questionnaire: ComplianceCheckQuestionnaire = new ComplianceCheckQuestionnaire();
}

export class ComplianceCheckQuestionnaire {
  isUserOriginalRecipient: boolean | null = null;
  submitter: Submitter = new Submitter();

  extensionStartSection: ComplianceCheckExtensionStartSection = new ComplianceCheckExtensionStartSection();

  // A 'standard' section is a section that is always shown in non-extension questionnaires,
  // and holds 1 to X questions. These are yes/no questions with a possible explanation,
  // that might be changed in the future, or additional ones might be added to a section
  standardSections: ComplianceCheckStandardSection[] = [];

  // An 'extension' section is a section that is only shown in extension questionnaires,
  // and holds 1 to X questions. These questions are open-answered questions, that are specific to extensions,
  // so they are handled separately from the standard sections
  extensionSections: ComplianceCheckExtensionSection[] = [];

  completedTruthfullyDeclarationText = '';
  hasCompletedTruthfully: boolean | null = null;

  noChangesToAssignmentDeclarationText = '';
  hasConfirmedNoChangesToAssignment: boolean | null = null;
}

export class Submitter {
  firstName = '';
  surname = '';
  emailAddress = '';
}

// The amount of questions per standard section
// When updating the amount of questions per section, or adding an additional section,
// be sure to update this as well
export const standardSectionQuestionCounts = [5, 3, 3, 3];

export class ComplianceCheckStandardSection {
  index = 0;
  header = '';
  questions: ComplianceCheckQuestion[] = [];
}

export class ComplianceCheckQuestion {
  index = 0;
  text = '';
  answer: boolean | null = null;
  explanation = '';
}

// Specific classes for extensions, because these don't follow the same yes/no structure and have additonal questions
export class ComplianceCheckExtensionStartSection {
  header = '';

  question1Text = '';
  willAssignmentBeExtended: boolean | null = null;

  question2Text = '';
  expectedEndDateChangedReason = '';

  question3Text = '';
  expectedEndDate: Date | null = null;

  question4Text = '';
  deliveriesExplanation = '';
}

export const extensionSectionQuestionCounts = [5, 3, 2, 3, 2, 1];

export class ComplianceCheckExtensionSection {
  index = 0;
  header = '';
  questions: ComplianceCheckExtensionQuestion[] = [];
}

export class ComplianceCheckExtensionQuestion {
  index = 0;
  text = '';
  answer = '';
}
